import { useState } from 'react';
import type { FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { ApiError } from '../../lib/api';

export function LoginPage() {
  const { login, status } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (status === 'authed') return <Navigate to="/" replace />;

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(username.trim(), password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : '登录失败，请重试');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-hero" aria-hidden="true">
        <div className="login-hero-brand">
          <div className="brand-mark logo"><img src="/logo.png" alt="Pinnacle Laser" /></div>
          <div>
            <b>Pinnacle Laser</b>
            <span>INTEGRAL BUSINESS PLATFORM</span>
          </div>
        </div>
        <div className="login-hero-body">
          <h2>从报价到交货，<em>一条主链</em>贯穿全业务</h2>
          <p>订单、客户工件、生产工单、质检与库存围绕「本次维修任务」关联运转；后台与现场看到同一份记录。</p>
          <div className="login-hero-feats">
            <div className="ft"><i>①</i><span>报价 → 合同 → 工单 → 检验 → 交货 全链路可追溯</span></div>
            <div className="ft"><i>②</i><span>核心服务真实数据，页面即业务，不做演示壳</span></div>
            <div className="ft"><i>③</i><span>按角色过滤入口，现场工程师与后台各见其责</span></div>
          </div>
        </div>
        <div className="login-hero-foot">© Pinnacle Laser / Mundo Laser · Web Console</div>
      </div>

      <div className="login-pane">
        <form className="login-card" onSubmit={submit}>
          <div className="login-brand">
            <div className="brand-mark logo"><img src="/logo.png" alt="Pinnacle Laser" /></div>
            <div className="brand-text">
              <b>一体化业务平台</b>
              <span>Pinnacle Laser · Integral Business Platform</span>
            </div>
          </div>

          <div className="login-form">
            <label className="field">
              <label>用户名</label>
              <input className="txt" type="text" autoComplete="username" value={username}
                onChange={(e) => setUsername(e.target.value)} autoFocus />
            </label>
            <label className="field">
              <label>密码</label>
              <input className="txt" type="password" autoComplete="current-password" value={password}
                onChange={(e) => setPassword(e.target.value)} />
            </label>
            {error ? <div className="notice bad">{error}</div> : null}
            <button className="btn primary" type="submit" disabled={busy || !username || !password} style={{ justifyContent: 'center', padding: '10px 12px' }}>
              {busy ? '正在验证…' : '登录'}
            </button>
          </div>

          <div className="login-foot">
            登录会话由核心服务签发（12 小时有效）。备用管理后台仍可在同域 <span className="num">/admin</span> 访问。
          </div>
        </form>
      </div>
    </div>
  );
}
